import { Kampos, effects } from 'kampos';
import { createWorker } from '../utilities/worker';
const WORKER_URL = 'https://static.parastorage.com/services/canvas/1.114.0/webworker/smear.umd.min.js';
export default async function create(target, options) {
  if (typeof target.transferControlToOffscreen !== 'function') {
    return null;
  }
  const {
    radius = 140,
    intensity = 0.28,
    duration = 120,
    forceDecay = 0.001,
    decayPower = 1,
    easingStart,
    easingEnd
  } = options.namedEffect;
  const height = target.height;
  const width = target.width;
  const worker = await createWorker(WORKER_URL);
  const mapTarget = document.createElement('canvas');
  mapTarget.width = width;
  mapTarget.height = height;
  const offscreen = mapTarget.transferControlToOffscreen();
  worker.postMessage({
    type: 'init',
    canvas: offscreen,
    width,
    height,
    radius,
    intensity,
    duration,
    forceDecay,
    decayPower,
    easingStart,
    easingEnd
  }, [offscreen]);

  // create the main instance that renders the displaced image
  const displacement = effects.displacement({
    scale: {
      x: 0,
      y: 0
    },
    enableBlueChannel: true
  });
  displacement.map = mapTarget;
  displacement.textures[0].update = true; // to update

  const instance = new Kampos({
    effects: [displacement],
    target
  });
  return {
    instance,
    play(_temp) {
      let {
        beforeDraw
      } = _temp === void 0 ? {} : _temp;
      this.instance.play(beforeDraw);
    },
    setters: {
      mouse(_ref) {
        let {
          x,
          y,
          active = true
        } = _ref;
        if (active) {
          worker.postMessage({
            type: 'addpoint',
            x,
            y
          });
        }
      },
      radius(r) {
        worker.postMessage({
          type: 'setuniform',
          name: 'radius',
          value: r
        });
      },
      intensity(i) {
        worker.postMessage({
          type: 'setuniform',
          name: 'intensity',
          value: i
        });
      },
      duration(a) {
        worker.postMessage({
          type: 'setuniform',
          name: 'duration',
          value: a
        });
      },
      forceDecay(f) {
        worker.postMessage({
          type: 'setuniform',
          name: 'forceDecay',
          value: f
        });
      },
      decayPower(p) {
        worker.postMessage({
          type: 'setuniform',
          name: 'decayPower',
          value: p
        });
      }
    },
    worker,
    resize(w, h) {
      const size = {
        width: w,
        height: h
      };
      mapTarget.width = w;
      mapTarget.height = h;
      instance.setSource(size);
      worker.postMessage({
        type: 'setuniform',
        name: 'dimensions',
        value: size
      });
    }
  };
}
//# sourceMappingURL=Smear.js.map